import { tokens } from 'styles/tokens';
import { StatusDoctorType, StatusRhType } from '../type';

export const getDoctorStatusText = (status?: StatusDoctorType) =>
	({
		pendent: 'Pendiente',
		compatible: 'Apto para puesto',
		incompatible: 'No apto para puesto',
		appointmentRequested: 'Cita solicitada',
		appointmentAccepted: 'Cita aceptada',
		incomplete: 'Incompleto',
		conditional: 'Apto condicionado',
	}[status || 'pendent']);

export const getRhStatusText = (status?: StatusRhType) =>
	({
		pendent: 'Pendiente',
		approved: 'Aprobado',
		rejected: 'Declinado',
	}[status || 'pendent']);

export const getStatusColor = (status?: StatusDoctorType | StatusRhType) =>
	({
		pendent: '#5082C2',
		approved: '#8DC63F',
		rejected: '#C22A58',
		compatible: '#8DC63F',
		incompatible: '#C22A58',
		incomplete: tokens.color_warning,
		appointmentRequested: '#1AB0E6',
		appointmentAccepted: '#6850C2',
		conditional: '#FFA500',
	}[status || 'pendent']);
